/* ============================================================
   ExpressMelts — Folate dataset (shared by all folate tools)
   Powers: Gap Estimator + Hidden Folate Loss (cooking) calculator.

   ⚠️  BEFORE LAUNCH: every value with "verify": true must be
   confirmed against IFCT 2017 (nin.res.in) + USDA and signed off
   by your nutritionist / medical reviewer. Targets follow NIH ODS
   DFE values; ICMR-NIN 2020 cites a lower adult RDA (~300 µg) — we
   surface both in the UI rather than hide the difference.

   Units: folate in micrograms (µg). Food values are RAW µg/100g.
   Edit this file to add foods or adjust numbers — no code changes
   needed in the calculator section.
   ============================================================ */
window.EM_FOLATE_DATA = {
  version: "1.0",
  updated: "2026-06-28",

  /* Daily target — µg DFE/day, by life stage */
  targets: {
    general:       { label: "Adult (general)",        value: 400, note: "ICMR-NIN ~300 µg; international 400 µg DFE" },
    teen:          { label: "Teen (14–18)",           value: 400 },
    planning:      { label: "Planning pregnancy",     value: 600, preg: true,  note: "Preconception — discuss timing with your doctor" },
    pregnant:      { label: "Pregnant",               value: 600, preg: true },
    breastfeeding: { label: "Breastfeeding",          value: 500, preg: true },
    peri:          { label: "Perimenopause / 50+",    value: 400 }
  },

  /* Cooking retention factors — fraction of folate KEPT */
  methods: {
    raw:      { label: "Raw / salad",            factor: 1.00 },
    steamed:  { label: "Steamed / microwaved",   factor: 0.90 },
    stirfry:  { label: "Quick stir-fry / sauté", factor: 0.70 },
    pressure: { label: "Pressure-cooked",        factor: 0.70 },
    boiled:   { label: "Boiled & drained",       factor: 0.50 },
    fried:    { label: "Deep-fried / overcooked",factor: 0.40 }
  },

  /* Extra multiplicative loss applied to cooked foods when reheated */
  reheatRetain: 0.75,

  /* Servings/week buckets → numeric servings used by the engine */
  frequency: [
    { id: "0",  label: "Never",   perWeek: 0 },
    { id: "1",  label: "1–2/wk",  perWeek: 1.5 },
    { id: "3",  label: "3–4/wk",  perWeek: 3.5 },
    { id: "5",  label: "5+/wk",   perWeek: 6 }
  ],

  /* Folate-rich foods.
     per100  = raw folate µg per 100 g
     portion = grams in one typical serving (Indian portions)
     method  = default cooking method id (user can change)
     veg     = vegetarian-friendly
     cooked  = true if reheat penalty can apply
     verify  = true → value still needs nutritionist sign-off */
  foods: [
    { id: "palak",    name: "Spinach / palak",          per100: 194, portion: 100, unit: "≈1 cup cooked", method: "boiled",   group: "greens",  veg: true,  cooked: true,  verify: false },
    { id: "methi",    name: "Methi / amaranth greens",  per100: 80,  portion: 100, unit: "≈1 cup cooked", method: "boiled",   group: "greens",  veg: true,  cooked: true,  verify: true  },
    { id: "dal",      name: "Dal (toor / masoor)",      per100: 180, portion: 150, unit: "1 katori",      method: "pressure", group: "legumes", veg: true,  cooked: true,  verify: false },
    { id: "chana",    name: "Chana / chickpea",         per100: 170, portion: 150, unit: "1 katori",      method: "boiled",   group: "legumes", veg: true,  cooked: true,  verify: false },
    { id: "rajma",    name: "Rajma (kidney beans)",     per100: 130, portion: 150, unit: "1 katori",      method: "pressure", group: "legumes", veg: true,  cooked: true,  verify: false },
    { id: "beetroot", name: "Beetroot",                 per100: 109, portion: 80,  unit: "½ cup",         method: "boiled",   group: "veg",     veg: true,  cooked: true,  verify: false },
    { id: "broccoli", name: "Broccoli / cabbage",       per100: 63,  portion: 90,  unit: "≈1 cup",        method: "steamed",  group: "veg",     veg: true,  cooked: true,  verify: false },
    { id: "bhindi",   name: "Okra / bhindi",            per100: 60,  portion: 90,  unit: "≈1 cup",        method: "stirfry",  group: "veg",     veg: true,  cooked: true,  verify: true  },
    { id: "egg",      name: "Egg",                      per100: 44,  portion: 50,  unit: "1 egg",         method: "steamed",  group: "nonveg",  veg: false, cooked: true,  verify: false },
    { id: "citrus",   name: "Orange / citrus",          per100: 30,  portion: 130, unit: "1 fruit",       method: "raw",      group: "fruit",   veg: true,  cooked: false, verify: false },
    { id: "avocado",  name: "Avocado",                  per100: 81,  portion: 70,  unit: "½ fruit",       method: "raw",      group: "fruit",   veg: true,  cooked: false, verify: false },
    { id: "banana",   name: "Banana",                   per100: 20,  portion: 120, unit: "1 medium",      method: "raw",      group: "fruit",   veg: true,  cooked: false, verify: false },
    { id: "nuts",     name: "Sunflower seeds / peanuts",per100: 145, portion: 30,  unit: "small handful", method: "raw",      group: "nuts",    veg: true,  cooked: false, verify: true  },
    { id: "fortified",name: "Fortified cereal / atta",  per100: 120, portion: 40,  unit: "per serving",   method: "raw",      group: "fortified", veg: true, cooked: false, verify: true }
  ],

  /* Folic-acid supplement → DFE multiplier (synthetic folic acid).
     Methylfolate (Q6's form) bypasses the conversion these DFE rules
     were written for — we surface that distinction in the UI. */
  folicAcidDFE: 1.7,

  /* Default foods shown before "add more" is expanded (keeps it ≈8 taps) */
  defaultFoodIds: ["palak", "dal", "chana", "broccoli", "citrus", "egg"]
};
